import React, { useContext, useEffect, useRef, useState } from "react";
import { CanvasContext } from "../../Components/core/workspace/CanvasContext";
import { BASE_TEMP_IMG, sendImages } from "../../Redux/App/action";
import { useDispatch } from "react-redux";
import axios from "axios";
import { BASE_URL_TEMPLATE, BASE_URL_MEDIA } from "../../Redux/App/action";
const BackDrop = () => {
  const { canvas, canvasRef } = useContext(CanvasContext);
  const [image, setImage] = useState("");
  const [userImage, setUserImage] = useState([]);
  localStorage.setItem("userImage", userImage);
  const imageRef = useRef(null);
  const dispatch = useDispatch();
  const [newtemplatedata, setNewTemplateData] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const handleClickImage = () => {
    imageRef.current.click();
  };
  const [tempc, setTempc] = useState([]);
  const [sourcemediaID, setSourcemediaID] = useState(null);
  const accessToken = localStorage.getItem("token");
  const [getalluserimage, setGetAllUserImage] = useState([]);
  const [page, setPage] = useState(0);
  const id = localStorage.getItem("cardid");

  // Define the API endpoint and headers
  const MEDIA_API_URL = `${BASE_URL_MEDIA}/media/file/admin/upload/raw?imageGroup=USER_CARD_IMAGES`;
  const API_HEADERS = {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${accessToken}`,
  };

  const getTemplate = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_TEMPLATE}/template-builder/by-source-media-id?sourceMediaId=${id}`
      );
      if (response.status === 200) {
        const responseData = response.data.payload.data;
        setTempc(responseData);
        localStorage.setItem("templateId", response.data.payload.templateId);
        const parsedData = JSON.parse(responseData);
        setNewTemplateData(parsedData);

        // Load fonts here
        await loadFonts(parsedData); // Make sure to await this function

        // Corrected variable name
      }
    } catch (error) {
      console.error("Error fetching template:", error);
    }
  };

  const loadFonts = async (templateData) => {
    const objects = templateData.objects;
    const fontPromises = [];

    for (let i = 0; i < objects.length; i++) {
      const object = objects[i];
      if (object.type === "textbox" && object.fontFamily) {
        const fontName = `customFont${i + 1}`;
        fontPromises.push(loadFont(fontName, object.fontFamily));
      }
    }

    try {
      // Wait for all fonts to load
      await Promise.all(fontPromises);
    } catch (error) {
      console.error("Error loading fonts:", error);
    }
  };

  // Function to load a font
  const loadFont = async (fontName, fontFamily) => {
    try {
      const fontFace = new FontFace(fontName, `url(${fontFamily})`);
      await fontFace.load();
      document.fonts.add(fontFace);
    } catch (error) {
      console.error("Error loading font:", error);
    }
  };

  useEffect(() => {
    getTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hangleImageChange = (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("originalFiles", file);
    dispatch(sendImages(formData));
    setImage(file);
  };

  const hostname = window.location.hostname;

  const addImg = (src) => {
    if (canvas) {
      let data = canvas.toJSON();
      const updatedTemplateData = { ...data };

      const firstImageObject = updatedTemplateData.objects.find(
        (obj) => obj.type === "image"
      );

      if (firstImageObject) {
        firstImageObject.src = userImage;
        let json = JSON.stringify(updatedTemplateData);

        if (json.includes("dev.api.wishfy.io")) {
          json = json.replaceAll("dev.api.wishfy.io", hostname);
        } else if (json.includes("api.wishfy.io")) {
          json = json.replaceAll("api.wishfy.io", hostname);
        } else if (json.includes("images.wishfy.io")) {
          json = json.replaceAll("images.wishfy.io", hostname);
        } else if (json.includes("ik.imagekit.io/bxndingik/dev")) {
          json = json.replaceAll(
            "ik.imagekit.io/bxndingik/dev",
            "wishfy-web-dev.wishfy.io"
          );
        } else if (json.includes("ik.imagekit.io/bxndingik")) {
          json = json.replaceAll("ik.imagekit.io/bxndingik", "wishfy.io");
        }

        canvas.loadFromJSON(json, () => {
          canvas.renderAll();
        });
      }
    }
  };

  const handleImageUpload = async (e) => {
    const selectedImage = e.target.files[0];

    if (selectedImage) {
      const formData = new FormData();
      formData.append("imageGroup", "USER_CARD_IMAGES");
      formData.append("originalFiles", selectedImage, selectedImage.name);

      try {
        const response = await axios.post(MEDIA_API_URL, formData, {
          headers: API_HEADERS,
        });

        const newImage = response.data;
        setGetAllUserImage([...getalluserimage, newImage]);
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const fetchNextPage = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/media/file/admin/get/byuserandimagegroup?imageGroup=USER_CARD_IMAGES&page=${page}&pageSize=5`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setGetAllUserImage((prevData) => [...prevData, ...response.data]);
      setPage(page + 1); // Increment the page number for the next fetch
    } catch (error) {
      console.error("Error fetching next page:", error);
    }
  };

  useEffect(() => {
    fetchNextPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="flex justify-center items-center gap-5 mb-6">
        <div>
          <div className="mb-4">
            <input
              type="file"
              className="hidden"
              id="imageInput"
              onChange={handleImageUpload}
            />
            <label
              className="cursor-pointer text-[#fff] bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 font-semibold rounded-[20px] text-sm px-5 py-2.5 text-center"
              htmlFor="imageInput"
            >
              UPLOAD IMAGES
            </label>
          </div>
          <div>
            <button
              className="text-[#fff] bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 rounded-[20px] text-sm font-semibold px-5 py-2.5 text-center"
              onClick={() => addImg(userImage)}
            >
              CLICK TO REPLACE
            </button>
          </div>
        </div>
      </div>
      <div className="flex overflow-x-auto gap-3 w-full">
        {getalluserimage &&
          getalluserimage.map((image, index) => {
            return (
              <section key={index} className="flex-shrink-0 border-2">
                <span>
                  <img
                    src={image.imageUrl}
                    className={`bg-purple-200 h-28 w-100% cursor-pointer ${
                      selectedImageIndex === index
                        ? "border-2 border-red-500"
                        : ""
                    }`}
                    alt="preview"
                    onClick={() => {
                      setUserImage(image.imageUrl);
                      setSelectedImageIndex(index); // Set the selected image index
                    }}
                  />
                </span>
              </section>
            );
          })}
      </div>
      {getalluserimage && getalluserimage?.length > 0 && (
        <div className="mt-4">
          <button
            className="text-[#fff] bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 rounded-[20px] text-sm font-semibold px-5 py-2.5 text-center"
            onClick={fetchNextPage}
          >
            VIEW MORE
          </button>
        </div>
      )}
    </>
  );
};
export default BackDrop;
